import { Deserializable } from '../../../models/protocols/deserializable';
import { Address } from '../../../models/users/dto/address';

export class FiduciaryOrganization implements Deserializable {
  public id!: number;
  public memberLegalFiduciaryId!: number;
  public name!: string;
  public phoneNumberCountryCode!: string;
  public phoneNumber!: string;
  public email!: string;
  public contactFirstName!: string | null;
  public contactLastName!: string | null;
  public address!: Address | null;

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;
    if (this.address) {
      this.address = Deserialize.instanceOf(Address, this.address);
    }
  }
}
